var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"text-success"},[_c('i',{staticClass:"fa fa-check-square-o fa-lg icon-button mr-1",attrs:{"title":"Aprovar Conformidade Técnica"},on:{"click":function($event){$event.stopPropagation();return _vm.confirmarAprovacaoTecnica()}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }